import React from 'react';
import type { MentionInputHandle } from '../MentionInput';

interface PendingPrefill {
  token: number;
  mode: 'message' | 'note';
  text: string;
}

// Consumes a `pendingPrefill` prop into the composer or note-mode textarea.
// The `onPrefillConsumed` callback is mirrored through a ref so the effect
// doesn't depend on parent-callback identity (which would re-run the effect
// every render).
export function useChatPrefill(
  pendingPrefill: PendingPrefill | null | undefined,
  onPrefillConsumed: (() => void) | undefined,
  setNoteMode: (v: boolean) => void,
  setNoteText: (v: string) => void,
  mentionInputRef: React.RefObject<MentionInputHandle>
): void {
  const onPrefillConsumedRef = React.useRef(onPrefillConsumed);
  onPrefillConsumedRef.current = onPrefillConsumed;
  React.useEffect(() => {
    if (!pendingPrefill) {
      return;
    }
    if (pendingPrefill.mode === 'note') {
      setNoteMode(true);
      setNoteText(pendingPrefill.text);
    } else {
      mentionInputRef.current?.setText(pendingPrefill.text);
    }
    onPrefillConsumedRef.current?.();
  }, [pendingPrefill, setNoteMode, setNoteText, mentionInputRef]);
}
